<template>
  <button
    id="teste-google"
    v-google-signin-button="value"
    @click="eventToOpen"
    class="google-signin-button"
  >
    Fazer Integração
  </button>
</template>

<script>
import GoogleSignInButton from "../../helperGoogle.js";
import axios from "axios";

export default {
  directives: {
    GoogleSignInButton,
  },
  data: () => ({
    value: {
      clientId:
        "1092877225119-kp565lhg86i35fjk7q92ie9sb4c22nhg.apps.googleusercontent.com",
      scope:
        "https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/spreadsheets.readonly https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.readonly",
    },
  }),
  methods: {
    eventToOpen() {
      this.$root.$emit("opengoogleint");
    },
    OnGoogleAuthSuccess(idToken) {
      console.log(idToken);
      idToken.title = this.$route.params.title;
      axios.post(
        process.env.VUE_APP_API_HOST + "/api/connection/google/code",
        idToken,
        {
          headers: {
            Authorization: this.$route.params.auth,
          },
        }
      );
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
    simulateClick() {
      setTimeout(() => {
        document.getElementById("teste-google").click();
        document
          .getElementById("teste-google")
          .classList.add("google-signin-button2");
      }, 500);
    },
  },
  mounted() {
    this.simulateClick();
  },
};
</script>

<style lang="scss" scoped>
.google-signin-button {
  border: none;
  background: rgba(255, 255, 255, 0);
  color: rgba(255, 255, 255, 0);
}

.google-signin-button2 {
  border: none;
  background: rgba(33, 51, 210, 0.1) !important;
  box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
  border-radius: 5px;
  width: 231.25px;
  height: 45px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.2px;
  color: #2a63ab !important;
}
</style>
